/**
 * Main entry point of the Polly app - the quick vote among friends, polly.liquido.vote.
 * Its own app next to LIQUIDO, in the same repository: see docs/liquido-architecture.md.
 */
import config from "config"  // mapped to the environment's config file, the same one LIQUIDO reads. See vite.config.js

console.log("=================")
console.log("WELCOME to Polly!")
console.log("=================")
console.log("config.source   = "+config.configSource)
console.log("LIQUIDO_API_URL = "+config.LIQUIDO_API_URL)

import { startApp } from "@/shared/shell/create-app.js"   // imports the global CSS first: Bootstrap, then liquido.css
import PollyApp from "@/polly/polly-app.vue"
import router from "@/polly/router.js"
import globalMessages from "@/shared/loc/global-messages.js"
import pollyMessages from "@/polly/services/polly-messages.js"

startApp({
	rootComponent: PollyApp,
	router,
	messages: [globalMessages, pollyMessages],   // the words both apps use, and Polly's own texts
})
